import { pipe, propOr } from 'lodash/fp';
import { createSelector } from 'reselect';

import { Banner } from '@skippay/core/modules/user/types';

import { UserState } from './reducer';

export const getUserConfig = (state: { user: UserState }): UserState => state.user;

export const getLatestUpdateTimestamp = createSelector(
	[getUserConfig],
	(userConfig) => userConfig.lastUpdateTimestamp
);

export const getBanners = createSelector(
	[getUserConfig],
	(userConfig: UserState) => userConfig.banners
);

export const getBannerById = (
	state: { user: UserState },
	props: { id: string }
): Banner | undefined => getBanners(state)?.[props.id];

export const getRequests = createSelector(
	[getUserConfig],
	(userConfig: UserState) => userConfig.requests
);

export const getConfig = createSelector(
	[getUserConfig],
	(userConfig: UserState) => userConfig.config
);

export const getModals = createSelector(
	[getUserConfig],
	(userConfig: UserState) => userConfig.modals
);

export const getUserCountry = createSelector([getUserConfig], (userConfig) => userConfig?.country);

export const getUserCountrySelector = pipe(getUserCountry, propOr(false, 'user'));
